var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.pram.id ? "编辑公司" : "新增公司",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "110px", model: _vm.pram } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "公司名称：",
                    prop: "companyName",
                    rules: [
                      {
                        required: true,
                        message: "请填写公司名称",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写公司名称" },
                    model: {
                      value: _vm.pram.companyName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "companyName", $$v)
                      },
                      expression: "pram.companyName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "税号：", prop: "taxNo" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写税号" },
                    model: {
                      value: _vm.pram.taxNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "taxNo", $$v)
                      },
                      expression: "pram.taxNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "注册地址：", prop: "registeredAddress" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写注册地址" },
                    model: {
                      value: _vm.pram.registeredAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "registeredAddress", $$v)
                      },
                      expression: "pram.registeredAddress",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "创建时间：",
                    prop: "userCreatedAt",
                    rules: [
                      {
                        required: true,
                        message: "请选择创建时间",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      placeholder: "请选择创建时间",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.pram.userCreatedAt,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "userCreatedAt", $$v)
                      },
                      expression: "pram.userCreatedAt",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("pram")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }